<template>
	<div>
		<v-card flat v-show="editor">
			<v-card flat>
				<v-card-text>
					<brace
						style="height:90vh;"
						class="kbet-editor"
						:mode="'json'"
						@code-change="onEditorCodeChange"
						@setHandler="
							h => {
								editorHandler = h;
							}
						"
					/>
				</v-card-text>
			</v-card>
		</v-card>
		<div style="height:100vh;overflow-y: auto;" v-show="!editor">
			<code class="code">{{ this.resultSummary }}</code>
			<div style="display:flex;">
				<span></span>
				<v-spacer></v-spacer>
				<v-btn outline flat color="purple darken-1" @click="selectAllFiles"
					>Select All</v-btn
				>
				<v-btn outline flat color="blue darken-1" @click="unselectAllFiles"
					>Unselect All</v-btn
				>
				<v-btn outline flat color="yellow darken-1" @click="invertSelection"
					>Invert Selection</v-btn
				>
			</div>
			<div
				v-for="(logItem, index) of tableLogResult"
				:key="logItem._id + index"
			>
				<template v-if="!logItem.data">
					<div class="checkbox-div">
						<div>
							<input
								v-model="selectedFiles"
								:id="logItem.filename"
								type="checkbox"
								:value="logItem.filename"
							/>
							<label :for="logItem.filename">{{ logItem.filename }}</label>
						</div>
						<v-btn
							outline
							flat
							color="green darken-1"
							@click="downloadFileFromServer(logItem.filename)"
							>Download File</v-btn
						>
						<!-- <v-checkbox
							color="orange accent-3"
							v-model="selectedFiles"
							:value="logItem.filename"
							:label="`Select file: ${logItem.filename}`"
						></v-checkbox>-->
					</div>
					<code class="code">{{ JSON.stringify(logItem, null, 2) }}</code>
				</template>
				<template v-else>
					<code class="code">{{ getLogProperties(logItem) }}</code>
					<div class="checkbox-div">
						<div>
							<input
								v-model="selectedFiles"
								:id="logItem.filename"
								type="checkbox"
								:value="logItem.filename"
							/>
							<label :for="logItem.filename">{{ logItem.filename }}</label>
						</div>
						<v-btn
							outline
							flat
							color="green darken-1"
							@click="downloadFileFromServer(logItem.filename)"
							>Download File</v-btn
						>
						<!-- <v-checkbox
							color="orange accent-3"
							v-model="selectedFiles"
							:value="logItem.filename"
							:label="`Select file: ${logItem.filename}`"
						></v-checkbox>-->
					</div>
					<div style="overflow-x:auto;padding:1%;">
						<div class="tableLight" id="results">
							<div class="theader">
								<div
									v-for="head in Object.keys(logItem.data[0])"
									:key="head"
									:class="['table_header', 'table_header_light']"
								>
									{{ head }}
								</div>
							</div>
							<div
								v-for="(row, key) in logItem.data"
								:key="logItem._id + index + key"
								:class="[
									'table_row',
									row['RESULT'] != 0
										? 'mildRed'
										: row['CALCULATED_ROW']
										? 'yellowHighlight'
										: row['ALPHABET_IN_CRITICAL_HEADERS']
										? 'greenHighlight'
										: row['HAS_SPACE_IN_CRITICAL_HEADERS']
										? 'blueHighlight'
										: '',
								]"
							>
								<div
									v-for="(rowItem, itemKey) in row"
									:key="itemKey"
									class="table_small"
								>
									<div class="table_cell">{{ itemKey }}</div>
									<div
										class="table_cell"
										style="text-align:left;margin: 0 20px 0 0;"
									>
										{{ rowItem }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<v-btn
			color="blue darken-1"
			small
			absolute
			top
			right
			fab
			@click="toggleLogDisplay"
		>
			<v-icon>{{ editor ? 'table_chart' : 'code' }}</v-icon>
		</v-btn>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import logViewerMixins from '../../mixins/logViewerMixins';
export default {
	components: {},
	mixins: [logViewerMixins],
	data() {
		return {
			editorHandler: false,
			displayJSON: false,
			editor: true,
			tableLogResult: [],
			resultSummary: {},
			selectedFiles: [],
		};
	},
	created() {
		this.setSelectedFilesForExtraction([]);
		this.selectedFiles = [];
	},
	methods: {
		...mapActions('fileExtraction', [
			'getFileJSON',
			'extractAndSaveMeta',
			'unlockFile',
		]),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapActions(['downloadFile']),
		...mapMutations('fileExtraction', [
			'refreshStockistListEmitter',
			'closeFileMetaDialog',
			'setSelectedFilesForExtraction',
		]),
		onEditorCodeChange(code) {
			this.editorCode = code;
		},
		toggleLogDisplay() {
			this.editor = !this.editor;
		},
		closeDialog() {
			// _id: "5cde85113e4a6e0b2701d6cc"
			this.unlockFile(this.selectedFile._id).then(data => {
				if (!data) {
					this.closeFileMetaDialog();
				}
			});
		},
		getLogProperties(logItem) {
			let a = '';
			for (let key in logItem) {
				if (key != 'data') a += `"${key}": "${logItem[key]}"` + '\n';
			}
			return a;
		},
		selectAllFiles() {
			// console.log(this.tableLogResult);
			for (let file of this.tableLogResult) {
				if (!this.selectedFiles.includes(file.filename) && file.data) {
					this.selectedFiles.push(file.filename);
				}
			}
		},
		unselectAllFiles() {
			this.selectedFiles = [];
		},
		invertSelection() {
			if (this.selectedFiles.length == 0) {
				this.selectAllFiles();
			} else if (this.selectedFiles.length == this.tableLogResult.length) {
				this.unselectAllFiles();
			} else {
				let temp = [];
				for (let file of this.tableLogResult) {
					if (!this.selectedFiles.includes(file.filename)) {
						temp.push(file.filename);
					}
				}
				this.selectedFiles = temp;
			}
		},
	},
	computed: {
		...mapGetters('fileExtraction', ['selectedFile', 'currentLogs']),
	},
	mounted() {
		this.editorHandler.setValue(JSON.stringify(this.currentLogs, null, 2));
	},
	watch: {
		currentLogs() {
			this.editorHandler.setValue(JSON.stringify(this.currentLogs, null, 2));
			this.tableLogResult = JSON.parse(JSON.stringify(this.currentLogs));
			this.resultSummary = this.tableLogResult.shift();
			if (this.editor) {
				this.toggleLogDisplay();
			}
			this.$emit('switchTab', 'tab-4');
		},
		selectedFiles(nv) {
			// console.log("Selected files:", nv, cv);
			this.setSelectedFilesForExtraction(nv.map(e => e.split('.')[0]));
		},
	},
	props: ['dataProp'],
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
.code {
	width: 100%;
	font-size: 14px;
	padding: 1%;
}
.checkbox-div {
	margin-left: 25px;
	margin-top: 20px;
	font-size: large;
	display: flex;
	flex-direction: row;
	justify-content: center;

	label {
		margin-left: 3px;
	}
}
.mildRed {
	background: lightcoral;
}
.yellowHighlight {
	background: rgba(255, 255, 0, 0.411);
}
.greenHighlight {
	background: rgba(144, 238, 144, 0.623);
}
.blueHighlight {
	background: lightblue;
}
.tableLight {
	display: table;
	text-align: center;
	width: 100%;
	margin: 1% auto 0;
	border-collapse: separate;
	/* font-family: 'Roboto', sans-serif; */
	font-weight: 400;
	/* padding: 1%; */
}
.tableDark {
	display: table;
	text-align: center;
	width: 100%;
	margin: 1% auto 0;
	border-collapse: separate;
	/* font-family: 'Roboto', sans-serif; */
	font-weight: 400;
	/* padding: 1%; */
}
.table_row {
	display: table-row;
}
.theader {
	display: table-row;
	text-align: left;
}
.table_header {
	padding-top: 10px;
	padding-left: 10px;
	padding-bottom: 10px;
	font-weight: 700;
}
.table_header_light {
	display: table-cell;
	border-bottom: #808080 1px solid;
	/* border-top:  1px solid; */
	background: #f0f0f0;
	color: #000;
}
.table_header_light:hover {
	cursor: pointer;
}
.table_header_dark:hover {
	cursor: pointer;
}
.table_header_dark {
	display: table-cell;
	border-bottom: #808080 1px solid;
	/* border-top:  1px solid; */
	background: #404040;
	color: #fff;
}
.table_small {
	display: table-cell;
}
.table_row > .table_small > .table_cell:nth-child(odd) {
	display: none;
	/* background: #bdbdbd; */
	/* color: #000; */
	padding-top: 3px;
	padding-bottom: 3px;
	min-width: 120px;
}
.table_row > .table_small > .table_cell {
	padding-top: 3px;
	padding-bottom: 3px;
	min-width: 120px;
	/* color: #000; */
	/* border-bottom: #808080 1px solid; */
}
@media screen and (max-width: 1200px) {
	.table {
		width: 100%;
	}
}
@media screen and (max-width: 700px) {
	.table {
		display: block;
		width: 100%;
	}
	.table_row:nth-child(2n + 3) {
		background: none;
	}
	.theader {
		display: none;
	}
	.table_row > .table_small > .table_cell:nth-child(odd) {
		display: table-cell;
		width: 50%;
	}
	.table_cell {
		display: table-cell;
		width: 50%;
	}
	.table_row {
		display: table;
		width: 100%;
		border-collapse: separate;
		padding-bottom: 20px;
		margin: 5% auto 0;
		text-align: center;
	}
	.table_small {
		display: table-row;
	}
	.table_row > .table_small:first-child > .table_cell:last-child {
		border-left: none;
	}
	.table_row > .table_small:last-child > .table_cell {
		border-bottom: #ccc 1px solid;
	}
	.table_row > .table_small > .table_cell:first-child {
		border-left: #ccc 1px solid;
	}
	.table_row > .table_small:first-child > .table_cell:first-child {
		border-top-left-radius: 5px;
		border-top: #ccc 1px solid;
	}
	.table_row > .table_small:first-child > .table_cell:last-child {
		border-top-right-radius: 5px;
		border-top: #ccc 1px solid;
	}
	.table_row > .table_small:last-child > .table_cell:first-child {
		border-right: none;
	}
	.table_row > .table_small > .table_cell:last-child {
		border-right: #ccc 1px solid;
	}
	.table_row > .table_small:last-child > .table_cell:first-child {
		border-bottom-left-radius: 5px;
	}
	.table_row > .table_small:last-child > .table_cell:last-child {
		border-bottom-right-radius: 5px;
	}
}
</style>
